import axios from 'axios/index';
import { UPLOAD_LOGO } from '../../utils/constants';

const setLogo = (hash, uiId, form) => {

    return axios.put(UPLOAD_LOGO(uiId),
        form,
        {
            headers: {
                "Accept": "application/json",
                "Accept-language": "bg",
                "Authorization": hash,
                "Content-Type": "multipart/form-data"
            }
        }
    ).then(resp => {

        return resp;
    }).catch(err => {
        console.error(err)
    })
}

export default setLogo;